import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import Table, {
  Cell,
  Row,
  TitleCell,
  TitleRow
} from 'components/ReusableComponents/Table'
import { directfulServiceNames } from 'main/directfulServices'
import moment from 'moment'
import { formatPrice } from 'utils/common'

import styles from './ServiceHistoryDialog.module.scss'

const periodLabels = {
  PostPay: 'Postpay',
  Monthly: 'Monthly',
  Quarterly: 'Quarterly',
  SemiAnnual: 'Semi-Annual',
  Annual: 'Annual'
}

const ServiceHistoryDialog = ({ subscriptions, onClose }) => {
  return (
    <ConfirmationDialog
      title="Service History"
      maxWidth={1200}
      contentPadding={0}
      onClose={onClose}
      hasConfirmButton={false}
    >
      <div className={styles.bookingsWrapper}>
        <div className={styles.tableHolder}>
          <Table widths={[180, 80, 110, 170, 110, 110, 110, 160]}>
            <TitleRow className={styles.titleRow}>
              <TitleCell>Service</TitleCell>
              <TitleCell>Rate</TitleCell>
              <TitleCell>Period</TitleCell>
              <TitleCell>Added by</TitleCell>
              <TitleCell>Added on</TitleCell>
              <TitleCell>Started on</TitleCell>
              <TitleCell>Ended on</TitleCell>
              <TitleCell>Ended by</TitleCell>
            </TitleRow>
            {subscriptions.map(b => (
              <Row className={styles.row} key={b.subsidiarySubscriptionId} styles={{}}>
                <Cell>
                  <span className={styles.serviceName}>
                    {directfulServiceNames[b.plan]}
                  </span>
                </Cell>
                <Cell>{formatPrice(b.planRate)}</Cell>
                <Cell>{periodLabels[b.period] || b.period || '-'}</Cell>
                <Cell>{b.addedBy}</Cell>
                <Cell>{moment(b.addedOn).format('MMM DD, YYYY')}</Cell>
                <Cell>{moment(b.startDate).format('MMM DD, YYYY')}</Cell>
                <Cell>
                  {b.isActive ? (
                    <span className={styles.active}>Active</span>
                  ) : b.endDate ? (
                    moment(b.endDate).format('MMM DD, YYYY')
                  ) : (
                    '-'
                  )}
                </Cell>
                <Cell>{b.endedBy || '-'}</Cell>
              </Row>
            ))}
          </Table>
        </div>
      </div>
    </ConfirmationDialog>
  )
}

export default ServiceHistoryDialog
